import L, { jsx as f, jsxs as h } from "react/jsx-runtime";
import { useState as x } from "react";
import { J as C, d as M, O as j } from "./createTheme-6e68f5ca.js";
import { ao as q, z as G, ak as U, p as $, E as B, al as F, V as k, D as z, e as J, d as V, f as H, i as Y, h as W, t as K, T as Q } from "./Search-4d6031ad.js";
import { r as X, G as T } from "./Grid2-9c5e91ab.js";
import { u as Z, a as ee } from "./SearchInput-47ac50eb.js";
function te(e, n) {
  return process.env.NODE_ENV === "production" ? () => null : (t, a, r, o, s) => {
    const c = r || "<<anonymous>>", i = s || a;
    return typeof t[a] < "u" ? new Error(`The ${o} \`${i}\` of \`${c}\` is deprecated. ${n}`) : null;
  };
}
const re = {
  configure: (e) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), C.configure(e);
  }
}, ne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: M,
  createChainedFunction: q,
  createSvgIcon: G,
  debounce: U,
  deprecatedPropType: te,
  isMuiElement: $,
  ownerDocument: B,
  ownerWindow: F,
  requirePropFactory: X,
  setRef: k,
  unstable_ClassNameGenerator: re,
  unstable_useEnhancedEffect: z,
  unstable_useId: J,
  unsupportedProp: Z,
  useControlled: V,
  useEventCallback: H,
  useForkRef: Y,
  useIsFocusVisible: W
}, Symbol.toStringTag, { value: "Module" }));
var w = { exports: {} };
(function(e) {
  function n(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(w);
var ae = w.exports, v = {};
const oe = /* @__PURE__ */ j(ne);
var y;
function se() {
  return y || (y = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return n.createSvgIcon;
      }
    });
    var n = oe;
  }(v)), v;
}
var I = {}, ie = ae;
Object.defineProperty(I, "__esModule", {
  value: !0
});
var R = I.default = void 0, ce = ie(se()), ue = L, le = (0, ce.default)(/* @__PURE__ */ (0, ue.jsx)("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), "LocationOn");
R = I.default = le;
const A = {
  LATITUDE: 28.4595,
  LONGITUDE: 77.0266
}, P = "point_of_interest", u = {
  ESTABLISHMENT: "establishment",
  TRAIN_STATION: "train_station",
  TRANSIT_STATION: "transit_station",
  BUS_STATION: "bus_station",
  AIRPORT: "airport",
  RAIL: "rail"
}, b = 5e4, _ = { current: null }, p = { current: null }, de = K((e) => ({
  icon: {
    color: e.palette.text.secondary,
    marginRight: e.spacing(2)
  }
})), E = {
  airport: u.AIRPORT,
  rail: u.TRAIN_STATION,
  bus: u.BUS_STATION
};
function pe() {
  return window.google && (_.current || (_.current = new window.google.maps.places.AutocompleteService())), !!_.current;
}
function fe(e) {
  return e ? e.map((n) => {
    const { id: t, description: a, place_id: r, structured_formatting: o } = n;
    return {
      id: t,
      structured_formatting: o,
      place: a,
      placeId: r
    };
  }) : [];
}
function me(e) {
  return e.map((n) => {
    const { id: t, name: a, vicinity: r, place_id: o, geometry: s } = n;
    return {
      id: t,
      name: a,
      vicinity: r,
      geometry: s,
      placeId: o,
      structured_formatting: {
        main_text: a,
        secondary_text: r
      }
    };
  });
}
function ge(e, n) {
  let t = e;
  return n === u.AIRPORT && (t = e.filter((r) => JSON.stringify([
    u.AIRPORT,
    u.ESTABLISHMENT,
    P
  ]) === JSON.stringify(r.types.sort()))), n === u.RAIL && (t = e.filter((r) => JSON.stringify([
    u.ESTABLISHMENT,
    u.TRAIN_STATION,
    u.TRANSIT_STATION,
    P
  ]) === JSON.stringify(r.types.sort()))), t.map((r) => {
    const { id: o, name: s, place_id: c, geometry: i } = r;
    return {
      id: o,
      name: s,
      placeId: c,
      lat: i.location.lat(),
      lng: i.location.lng()
    };
  });
}
function N() {
  return window.google && (p.current || (p.current = new window.google.maps.places.PlacesService(
    document.createElement("div")
  ))), !!p.current;
}
function he(e) {
  const n = de(), [t, a] = x(null);
  function r(c) {
    return pe() ? new Promise((l) => {
      _.current.getPlacePredictions(
        { input: c },
        (d) => l(fe(d))
      );
    }) : Promise.resolve([]);
  }
  function o(c) {
    const {
      currentLocation: {
        lat: i = A.LATITUDE,
        lng: l = A.LONGITUDE
      },
      radius: d = b
    } = e;
    if (!N())
      return Promise.resolve([]);
    const m = {
      radius: d,
      location: new window.google.maps.LatLng(i, l),
      keyword: c
    };
    return new Promise(
      (S) => p.current.nearbySearch(
        m,
        (g) => S(me(g))
      )
    );
  }
  function s(c, i, l) {
    const { inputValue: d } = l, { main_text: O, secondary_text: m } = i.structured_formatting, S = ee(O, d);
    return /* @__PURE__ */ f("div", { ...c, children: /* @__PURE__ */ h(T, { container: !0, alignItems: "center", children: [
      /* @__PURE__ */ f(T, { children: /* @__PURE__ */ f(R, { className: n.icon }) }),
      /* @__PURE__ */ h(T, { xs: !0, children: [
        S.map((g, D) => /* @__PURE__ */ f(
          "span",
          {
            className: `${g.highlight ? "font-bold" : "font-normal"} whitespace-pre`,
            children: g.text
          },
          D
        )),
        m && /* @__PURE__ */ f(Q, { variant: "body2", color: "textSecondary", children: m })
      ] })
    ] }) });
  }
  return {
    value: t,
    onChange: a,
    fetchOptions: e ? o : r,
    renderOption: s,
    labelField: "place"
  };
}
function _e(e) {
  var o, s;
  const { formatted_address: n, geometry: t, id: a, place_id: r } = e ?? {};
  return {
    id: a,
    placeId: r,
    place: n,
    lat: (o = t == null ? void 0 : t.location) == null ? void 0 : o.lat(),
    lng: (s = t == null ? void 0 : t.location) == null ? void 0 : s.lng()
  };
}
function ye(e) {
  return N() ? new Promise((t) => {
    p.current.getDetails(
      { placeId: e.placeId },
      (a) => t(_e(a))
    );
  }) : Promise.resolve(null);
}
function Ae(e) {
  if (!N())
    return Promise.resolve(null);
  const { lat: t, lng: a, type: r, keyword: o, radius: s = b } = e, i = {
    location: new window.google.maps.LatLng(t, a),
    radius: s,
    type: E[r],
    keyword: o
  };
  return new Promise((l) => {
    p.current.nearbySearch(
      i,
      (d) => l(ge(d, E[r]))
    );
  });
}
export {
  A as D,
  Ae as f,
  ye as g,
  ae as i,
  se as r,
  he as u
};
//# sourceMappingURL=utils.entry-04e4214a.js.map
